import {
  Paragraph,
  TextRun,
  Table,
  TableRow,
  TableCell,
  WidthType,
  BorderStyle,
  AlignmentType,
} from 'docx';

const RISK_COLOR = {
  low: '04aa00', 1: '04aa00',
  medium: 'd0c407', 2: 'd0c407',
  high: 'ba3b46', 3: 'ba3b46',
};

const NONE = { style: BorderStyle.NONE, size: 0, color: 'FFFFFF' };
const NO_BORDERS = { top: NONE, bottom: NONE, left: NONE, right: NONE };
const TABLE_NO_BORDERS = { ...NO_BORDERS, insideH: NONE, insideV: NONE };

export function renderRiskBlockDocx({ children, riskidata = [] }) {
  if (!riskidata?.length) {
    children.push(
      new Paragraph({
        children: [new TextRun({ text: 'Ei riskitietoja saatavilla.', bold: true, size: 22 })],
        spacing: { after: 120 },
      })
    );
    return;
  }

  // Intro paragraph
  children.push(
    new Paragraph({
      children: [
        new TextRun({
          text: 'Kuntoluokituksen lisäksi käytämme kansainvälisesti tunnettua liikennevalomalliin perustuvaa riskiluokitusta. Riskiluokitus on alla olevan mukainen:',
          size: 22,
        }),
      ],
      alignment: AlignmentType.JUSTIFIED,
      spacing: { after: 120 },
    })
  );

  // Legend row
  children.push(
    new Paragraph({
      children: [
        new TextRun({ text: '✓  Matala riski', color: '04aa00', bold: true, size: 22 }),
        new TextRun({ text: '      ' }),
        new TextRun({ text: '✓  Keskitason riski', color: 'd0c407', bold: true, size: 22 }),
        new TextRun({ text: '      ' }),
        new TextRun({ text: '✓  Korkea riski', color: 'ba3b46', bold: true, size: 22 }),
      ],
      spacing: { after: 200 },
    })
  );

  // Group items by category
  const grouped = riskidata.reduce((acc, item) => {
    (acc[item.category] ||= []).push(item);
    return acc;
  }, {});

  for (const [category, items] of Object.entries(grouped)) {
    // Category heading with bottom border to simulate the green line
    children.push(
      new Paragraph({
        children: [new TextRun({ text: category.toUpperCase(), bold: true, size: 24, color: '198754' })],
        border: { bottom: { style: BorderStyle.SINGLE, size: 8, color: '198754' } },
        spacing: { before: 240, after: 100 },
      })
    );

    const rows = items.map(item => {
      const hasRisk = !!item.risk;
      const mark = hasRisk ? '✓' : '—';
      const color = hasRisk ? (RISK_COLOR[item.risk] || '000000') : '999999';
      const desc = hasRisk ? (item.description || '') : '';

      return new TableRow({
        children: [
          new TableCell({
            children: [
              new Paragraph({
                children: [new TextRun({ text: item.label, bold: true, size: 22 })],
                spacing: { after: 40 },
              }),
            ],
            width: { size: 30, type: WidthType.PERCENTAGE },
            borders: NO_BORDERS,
          }),
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({ text: `${mark}  `, color, bold: true, size: 22 }),
                  new TextRun({ text: desc, size: 22 }),
                ],
                spacing: { after: 40 },
              }),
            ],
            width: { size: 70, type: WidthType.PERCENTAGE },
            borders: NO_BORDERS,
          }),
        ],
      });
    });

    children.push(
      new Table({
        rows,
        width: { size: 100, type: WidthType.PERCENTAGE },
        borders: TABLE_NO_BORDERS,
      })
    );

    // Spacer after each category
    children.push(new Paragraph({ children: [new TextRun('')], spacing: { after: 120 } }));
  }
}
